import { render } from "./mvt-listproperty.vue?vue&type=template&id=0763b918"
import script from "./mvt-listproperty.js?vue&type=script&lang=js"
export * from "./mvt-listproperty.js?vue&type=script&lang=js"

import "./mvt-listproperty.vue?vue&type=style&index=0&id=0763b918&lang=scss"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__